// @mui icons
import Icon from "@mui/material/Icon";

// import Dashboard from "views/Dashboard/Dashboard.js";

// Admin Pages
import UserAdmin from 'clients/admin/UserAdmin/UserAdmin'
import RolesAdmin from 'clients/admin/RolesAdmin/RolesAdmin'
import StoreAdmin from 'clients/admin/StoreAdmin/StoreAdmin'
import ReportAdmin from 'clients/admin/ReportAdmin/ReportAdmin'
import DashboardAdmin from 'clients/admin/DashboardAdmin/DashboardAdmin'
import DataDirectorPage from 'containers/DataDirectorPage'
import StoreRecordPage from 'pages/clients/grm/temp-pages/StoreRecordPage'
import LocationAdmin from 'pages/common/admin/LocationAdmin'
import PeopleAdmin from 'pages/common/admin/PeopleAdmin'
import ResourceAdmin from 'pages/common/admin/ResourceAdmin'
import TestListAreas3 from "pages/common/admin/TestListAreas3";
import MetricDataDevTool from 'pages/common/tools/MetricDataDevTool';

// Report Pages
import R0001Main from 'clients/grm/views/R0001/R0001Main'
import R0002Main from 'clients/grm/views/R0002/R0002Main'
import R0003Main from 'clients/grm/views/R0003/R0003Main'
import R0004Main from 'clients/grm/views/R0004/R0004Main'
import R0005Main from 'containers/clients/grm/R0005/R0005Main'
import R0006 from 'pages/common/reports/R0006'

// @material-ui/icons
// import Build from "@material-ui/icons/Build";
// import DashboardIcon from "@material-ui/icons/Dashboard";
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import { vi } from "date-fns/locale";
import MigrationRunner from "pages/clients/grm/temp-pages/MigrationRunner";
import StoreMigrationManager from "pages/clients/grm/temp-pages/StoreMigrationManager";

const reportViews = {
  r0001: {
    name: 'Metrics Report',
    key: 'r0001',
    route: '/planning-tools/r0001',
    component: <R0001Main />
  },
  r0002: {
    name: 'Summary Report',
    key: 'r0002',
    route: "/planning-tools/r0002",
    // component: <R0002Report />
    component: <R0002Main />
  },
  r0003: {
    name: 'SPLH Report',
    key: 'r0003',
    route: '/planning-tools/r0003',
    component: <R0003Main />
  },
  r0004: {
    name: 'Product Mix Report',
    key: 'r0004',
    route: '/planning-tools/r0004',
    component: <R0004Main />
  },
  r0005: {
    name: 'Revenue Projections',
    key: 'r0005',
    route: '/planning-tools/r0005',
    component: <R0005Main />
  },
  r0006: {
    name: 'Efficiency & Productivity',
    key: 'r0006',
    route: '/planning-tools/r0006',
    component: <R0006 />
  }
}

const adminViews = {
  rolesAdmin: {
    name: "Roles Admin",
    key: 'roles-admin',
    route: "/rolesAdmin",
    component: <RolesAdmin />,
  },
  userAdmin: {
    name: "User Admin",
    key: 'user-admin',
    route: "/userAdmin",
    component: <UserAdmin />,
  },
  storeAdmin: {
    name: "Store Admin",
    key: 'store-admin',
    route: "/storeAdmin",
    component: <StoreAdmin />,
  },
  reportAdmin: {
    name: "Report Admin",
    key: 'report-admin',
    route: "/reportAdmin",
    component: <ReportAdmin />,
  },
  dataDirector: {
    name: "Data Director",
    key: 'data-director',
    route: "/dataDirector",
    component: <DataDirectorPage />,
  },
  dashboardAdmin: {
    name: "Dashboard Admin",
    key: 'dashboard-admin',
    route: '/dashboardAdmin',
    component: <DashboardAdmin />
  },
  migrationRunner: {
    name: "Store Migration",
    key: 'store-migration',
    route: '/storeMigration',
    component: <MigrationRunner />
  },
  storeMigrationManager: {
    name: "Store Migration Manager",
    key: 'store-migration-manager',
    route: '/grm/temp-pages/store-migration-manager',
    component: <StoreMigrationManager />
  },
  locationAdmin: {
    name: "Organization",
    key: 'location-admin',
    route: '/admin/location-admin',
    component: <LocationAdmin />
  },
  peopleAdmin: {
    name: "People",
    key: 'people-admin',
    route: '/admin/people-admin',
    component: <PeopleAdmin />
  },
  resourceAdmin: {
    name: "Resources",
    key: 'resource-admin',
    route: '/admin/resource-admin',
    component: <ResourceAdmin />
  }
}

export default function grmRoutes(name, role, permissions) {
  console.log("grmRoutes", name, role, permissions)
  
  let reportViewArr = []
  let adminViewArr = []
  let devViewArr = []

  // Setup Admin Views - Released features available to all admins
  switch(role) {
    case 'Admin':
      adminViewArr[0] = adminViews.rolesAdmin
      adminViewArr[1] = adminViews.userAdmin
      adminViewArr[2] = adminViews.reportAdmin
      adminViewArr[3] = adminViews.dashboardAdmin
      adminViewArr[4] = adminViews.storeAdmin
      break;
    default:
      // No action, leave as empty array
  }

  // Setup Dev Tools - Restricted to Dev User and Radix Admin only
  // The 'name' parameter is displayName from setUserRoutes (either firstName+lastName or userName)
  if (name === 'Dev User' || name === 'Radix Admin' || name === 'devuser' || name === 'radixadmin') {
    devViewArr.push(adminViews.dataDirector)
    devViewArr.push(adminViews.locationAdmin)
    devViewArr.push(adminViews.peopleAdmin)
    devViewArr.push(adminViews.resourceAdmin)

    devViewArr.push({
      name: "StoreRecord",
      key: 'store-record',
      route: "/store-record",
      component: <StoreRecordPage />,
    })

    devViewArr.push({
      name: "MigrationRunner",
      key: 'migration-runner',
      route: "/migration-runner",
      component: <MigrationRunner />,
    })

    devViewArr.push(adminViews.storeMigrationManager)

    devViewArr.push({
      name: "ListAreas3",
      key: 'listAreas3',
      route: '/listAreas3',
      component: <TestListAreas3 />,
    })

    devViewArr.push({
      name: "MetricData Dev Tool",
      key: 'metric-data-dev-tool',
      route: '/dev-tools/metric-data',
      component: <MetricDataDevTool />,
    })
  }
  // console.log('permissions', permissions)
  // Setup Report Views

  const normalizedRole = role.toLowerCase()

  // Add R0006 for specific roles - matches accessControl.js
  const r0006AuthorizedRoles = ['admin', 'exec', 'areamgr', 'genmgr']
  
  console.log('R0006 Access Check - Name:', name, 'Role:', role, 'Normalized Role:', normalizedRole)
  
  if (r0006AuthorizedRoles.includes(normalizedRole)) {
    console.log(`✓ R0006 access granted for role: ${role}`)
    reportViewArr.push(reportViews.r0006)
  } else {
    console.log(`✗ R0006 access not granted for role: ${role}`)
  }

  let arrIdx = reportViewArr.length
  for(let i = 0; i < permissions.length; i++){
    let report = permissions[i].report
    report = report.toLowerCase()
    if(report in reportViews){
      let viewPermissions = permissions[i].viewPermissions
      if(viewPermissions !== 'no-permission'){
        if (report !== 'r0006') {
          reportViewArr[arrIdx] = reportViews[report]
          arrIdx += 1
        }
      }
    }
  }
  // console.log('reportViewArr', reportViewArr)

  
  // // Main Dashboard View
  // const dashboard = {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   icon: DashboardIcon,
  //   component: Dashboard,
  //   layout: "/admin",
  // }

  // Create Routes - Order: Planning Tools (most accessible), Admin Tools (admin only), Dev Tools (dev only)
  let routes = []

  // Planning Tools - accessible based on permissions
  if(reportViewArr.length > 0){
    let reportRoutes = {
      type: 'collapse',
      name: 'Planning Tools',
      key: 'planning-tools',
      icon: <Icon fontSize='medium'>format_list_numbered_icon</Icon>,
      collapse: reportViewArr,  
    }
    routes.push(reportRoutes)
  }

  // Admin Tools - released features for admins
  if(adminViewArr.length > 0) {
    let adminRoutes = {
      type: 'collapse',
      name: "Admin Tools",
      key: 'admin-tools',
      icon: <Icon fontSize='medium'>content_paste</Icon>,
      collapse: adminViewArr,
    }
    routes.push(adminRoutes)
  }

  // Dev Tools - features under development, restricted to Dev User and Radix Admin
  if(devViewArr.length > 0) {
    let devRoutes = {
      type: 'collapse',
      name: "Dev Tools",
      key: 'dev-tools',
      icon: <Icon fontSize='medium'>code</Icon>,
      collapse: devViewArr,
    }
    routes.push(devRoutes)
  }

  let finalDivider = {
    type: 'divider', key: 'final-divider'
  }

  routes.push(finalDivider)
  
  return routes
}